import { Checkout } from '@/services';
import { SET } from '../';
import { cloneDeep } from 'lodash';

export default {
    namespaced: true,
    state: {
        cart: null
    },
    getters: {
        get(state) {
            return key => state[key];
        },
        cartsCount: (state) => {
            var count = 0;
            var cart = state.cart
            if (cart && cart.productList) {
                count += cart.productList
                    .map((x) => x.quantity)
                    .reduce((amount, quantity) => amount + quantity, 0)
                count += cart.treatmentIds.length
                count += cart.bundlesList
                    .map((x) => x.quantity)
                    .reduce((amount, quantity) => amount + quantity, 0)
            }


            return count;
        },
        cartCount: (state) => {
            var count = 0;
            var cart = state.cart
            if (cart) {
                count += cart.productList
                    .map((x) => x.quantity)
                    .reduce((amount, quantity) => amount + quantity, 0)
                count += cart.treatmentIds.length
                count += cart.bundlesList
                    .map((x) => x.quantity)
                    .reduce((amount, quantity) => amount + quantity, 0)

            }

            return count;
        },
        cartBundles: (state, getters, rootState) => {

            var bundles = state.cart?.bundlesList || []
            var activeSites = rootState.webshop.settings.activatedSalons.map(x => x.siteId)
            var deliverySites = rootState.webshop.settings.activatedSalons.filter(s => s.homeShipmentEnabled).map(s => s.siteId) || []
            var filteredBundles = bundles.filter(async bundle => {
                var b = cloneDeep(bundle)
                var subs = b.subscriptionsList.filter(s => activeSites.includes(s.siteId))

                subs.forEach(s => {
                  var stocks = []
                  b.products.forEach(p => {
                    var productStock = p.stockCountSalons[s.siteId] ?? 0
                    stocks.push(productStock)
                  })
                  if (s.availableAmount == 0 || s.availableAmount > Math.min(...stocks)) {
                    s.availableAmount = Math.min(...stocks)
                  } else if (Math.min(...stocks) > b.maxPerCustomer) {
                    s.availableAmount = b.maxPerCustomer
                  }
                })
        
                Object.assign(b, {subscriptionList: subs})
                var onlineStocks = b.subscriptionsList.filter(x => activeSites.includes(x.siteId))?.map(x => x.stockAmount)
                var shipmentStock = b.subscriptionsList.filter(x => deliverySites.includes(x.siteId))?.map(x => x.stockAmount)
                b.onlineStock = onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0
                b.stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a, b) => a + b) : 0

                return b
              });
            return filteredBundles || []
        },
        cartProducts: (state) => {
            return state.cart?.productList || []
        },
        cartTreatments: (state) => {
            return state.cart?.treatments || []
        },
        cartSite: (state) => {
            return state.cart?.siteId || []
        },
        cartProduct: (state) => (payload) => {
            var cart = state.cart
            return cart && cart.productList ? cart?.productList.find(p => p.id === payload.id) : []
        },
        cartBundle: (state) => (payload) => {
            var cart = state.cart
            return cart && cart.bundlesList ? cart?.bundlesList.find(p => p.campaignId === payload.id) : []
        },
        salonPool: (state, getters, rootState) => {
            var activeSites = rootState.webshop.settings.activatedSalons.map(x => x.siteId)
            var products = state.cart?.productList || [];
            var bundles = getters.cartBundles || [];
            var productsStock = []

            if (products.length) {
                for (var i in products) {
                    var product = products[i]
                    var stock = product.stockAmount.filter(s => activeSites.includes(s.siteId) && s.productStockAmount >= product.quantity)
                    stock.forEach(s => productsStock.push(s.siteId))
                }
            }

            if (bundles.length) {
                for (var j in bundles) {
                    var bundle = bundles[j]
                    var bundlestock = bundle.subscriptionsList.filter(s => activeSites.includes(s.siteId) && (s.availableAmount >= bundle.quantity))
                    bundlestock.forEach(s => productsStock.push(s.siteId))
                }
            }

            if (products.length || bundles.length) {
                const counts = {};
                productsStock.forEach(function (x) { counts[x] = (counts[x] || 0) + 1; });

                return [...new Set(productsStock)].filter(x => counts[x] == (products.length+bundles.length))
            }

            return activeSites
        }
    },
    mutations: {
        SET,
        UPDATE_CART(state, cart) {
            state.cart = cart
        },
        REMOVE_CART(state) {
            state.cart = {}
        }
    },
    actions: {
        async insertOrUpdateProduct({ commit }, payload) {
            let response = await Checkout.InsertOrUpdateProduct(payload);
            commit('UPDATE_CART', response.data.cart[0]);
            return response
        },
        async getShoppingCart({ commit }, payload) {
            let response = await Checkout.GetShoppingCart(payload);
            commit('SET', {
                key: 'cart',
                value: response.data.responseCode === 200 ? response.data.cart[0] : []
            });
            return response
        },
        async getShoppingCarts({ commit }, payload) {
            let response = await Checkout.GetShoppingCarts(payload);
            commit('SET', {
                key: 'cart',
                value: response.data.cart[0]
            });
            return response
        },
        async removeItemFromCart({ commit }, payload) {
            let response = await Checkout.RemoveItemFromCart(payload);
            if (response.data.responseCode === 200) {
                if (payload.deleteAllItems || !response.data.cart[0]) {
                    commit('REMOVE_CART', payload.siteId);
                } else {
                    commit('UPDATE_CART', response.data.cart[0]);
                }
            }
            return response
        },
        async removeTreatmentFromCart({ commit }, payload) {
            let response = await Checkout.RemoveItemFromCart(payload);
            if (response.data.responseCode === 200) {
                if (!response.data.cart[0]) {
                    commit('REMOVE_CART', payload.siteId);
                } else {
                    commit('UPDATE_CART', response.data.cart[0]);
                }
            }
            return response
        },
        async dropShoppingCart({ commit }, siteId) {
            commit('SET', {
                key: 'cart',
                value: null
            });
            return await Checkout.DropShoppingCart() && await Checkout.RemoveItemFromCart({
                siteId: siteId,
                deleteAllItems: true
            });
        }
    }
};
